// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { BallBounceDataWire, BallBounceDataWireT } from '../mannequin/ball-bounce-data-wire';
import { BallHitDataWire, BallHitDataWireT } from '../mannequin/ball-hit-data-wire';
import { BallHitLaunchWire, BallHitLaunchWireT } from '../mannequin/ball-hit-launch-wire';
import { BallHitRefinedWire, BallHitRefinedWireT } from '../mannequin/ball-hit-refined-wire';
import { BallPitchDataWire, BallPitchDataWireT } from '../mannequin/ball-pitch-data-wire';
import { BallPitchRefinedWire, BallPitchRefinedWireT } from '../mannequin/ball-pitch-refined-wire';
import { BallPolynomialDataWire, unionToBallPolynomialDataWire, unionListToBallPolynomialDataWire } from '../mannequin/ball-polynomial-data-wire';
import { BallThrowData, BallThrowDataT } from '../mannequin/ball-throw-data';


export class BallPolynomialWire implements flatbuffers.IUnpackableObject<BallPolynomialWireT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):BallPolynomialWire {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsBallPolynomialWire(bb:flatbuffers.ByteBuffer, obj?:BallPolynomialWire):BallPolynomialWire {
  return (obj || new BallPolynomialWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsBallPolynomialWire(bb:flatbuffers.ByteBuffer, obj?:BallPolynomialWire):BallPolynomialWire {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new BallPolynomialWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

id():string|null
id(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
id(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

timestamp():string|null
timestamp(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
timestamp(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

dataType():BallPolynomialDataWire {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : BallPolynomialDataWire.NONE;
}

data<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startBallPolynomialWire(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addId(builder:flatbuffers.Builder, idOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, idOffset, 0);
}

static addTimestamp(builder:flatbuffers.Builder, timestampOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, timestampOffset, 0);
}

static addDataType(builder:flatbuffers.Builder, dataType:BallPolynomialDataWire) {
  builder.addFieldInt8(2, dataType, BallPolynomialDataWire.NONE);
}

static addData(builder:flatbuffers.Builder, dataOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, dataOffset, 0);
}

static endBallPolynomialWire(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createBallPolynomialWire(builder:flatbuffers.Builder, idOffset:flatbuffers.Offset, timestampOffset:flatbuffers.Offset, dataType:BallPolynomialDataWire, dataOffset:flatbuffers.Offset):flatbuffers.Offset {
  BallPolynomialWire.startBallPolynomialWire(builder);
  BallPolynomialWire.addId(builder, idOffset);
  BallPolynomialWire.addTimestamp(builder, timestampOffset);
  BallPolynomialWire.addDataType(builder, dataType);
  BallPolynomialWire.addData(builder, dataOffset);
  return BallPolynomialWire.endBallPolynomialWire(builder);
}

unpack(): BallPolynomialWireT {
  return new BallPolynomialWireT(
    this.id(),
    this.timestamp(),
    this.dataType(),
    (() => {
      const temp = unionToBallPolynomialDataWire(this.dataType(), this.data.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: BallPolynomialWireT): void {
  _o.id = this.id();
  _o.timestamp = this.timestamp();
  _o.dataType = this.dataType();
  _o.data = (() => {
      const temp = unionToBallPolynomialDataWire(this.dataType(), this.data.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class BallPolynomialWireT implements flatbuffers.IGeneratedObject {
constructor(
  public id: string|Uint8Array|null = null,
  public timestamp: string|Uint8Array|null = null,
  public dataType: BallPolynomialDataWire = BallPolynomialDataWire.NONE,
  public data: BallBounceDataWireT|BallHitDataWireT|BallHitLaunchWireT|BallHitRefinedWireT|BallPitchDataWireT|BallPitchRefinedWireT|BallThrowDataT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const id = (this.id !== null ? builder.createString(this.id!) : 0);
  const timestamp = (this.timestamp !== null ? builder.createString(this.timestamp!) : 0);
  const data = builder.createObjectOffset(this.data);

  return BallPolynomialWire.createBallPolynomialWire(builder,
    id,
    timestamp,
    this.dataType,
    data
  );
}
}
